// Centralized store image registry built from public/images/store directories.
// We use product name-based matching and ignore any filenames that indicate missing assets (e.g., starting with "eksik").

// NOTE: Filenames below must exactly match files under public/images/store/Giyim and /Ayakkabı.
// We include both the base image (no index) and numbered variants when available.

export const GIYIM_FILES: string[] = [
  'Abdullah Kiğılı Exclusive — Checked Wool-Blend Blazer, Navy.webp',
  'Abdullah Kiğılı Exclusive — Checked Wool-Blend Blazer, Navy-1.webp',
  'Abdullah Kiğılı Exclusive — Checked Wool-Blend Blazer, Navy-2.webp',
  'Abdullah Kiğılı Exclusive — Windowpane Wool-Blend Blazer, Grey:Navy.webp',
  'Abdullah Kiğılı Exclusive — Windowpane Wool-Blend Blazer, Grey:Navy-1.webp',
  'Abdullah Kiğılı Exclusive — Windowpane Wool-Blend Blazer, Grey:Navy-2.webp',
  'AllSaints — Palm Collage Camp-Collar Shirt .webp',
  'AllSaints — Palm Collage Camp-Collar Shirt -1.webp',
  'AllSaints — Palm Collage Camp-Collar Shirt -2.webp',
  'Alpha Industries — B-15 Inspired Flight Jacket, Sage Green.webp',
  'Alpha Industries — B-15 Inspired Flight Jacket, Sage Green-2.webp',
  'Alpha Industries — B-15 Inspired Flight Jacket, Sage Green-3.webp',
  'Baldessarini — Short-Sleeve Camp-Collar Shirt, Bird:Floral Print.webp',
  'Baldessarini — Short-Sleeve Camp-Collar Shirt, Bird:Floral Print-1.webp',
  'Baldessarini — Short-Sleeve Camp-Collar Shirt, Bird:Floral Print-2.webp',
  'Balmain — Crest Patch Cotton Piqué Polo, Black.webp',
  'Balmain — Crest Patch Cotton Piqué Polo, Black-1.webp',
  'Balmain — Crest Patch Cotton Piqué Polo, Black-2.webp',
  'Balmain — Crest Patch Cotton Piqué Polo, Black-3.webp',
  'Balmain — Logo Piqué Polo, Black.webp',
  'Balmain — Logo Piqué Polo, Black-1.webp',
  'Balmain — Logo Piqué Polo, Black-2.webp',
  'Balmain — Logo T-Shirt & Swim Shorts Set, Black.webp',
  'Balmain — Logo T-Shirt & Swim Shorts Set, Black-1.webp',
  'Balmain — Logo T-Shirt & Swim Shorts Set, Black-2.webp',
  'Balmain — Logo T-Shirt & Swim Shorts Set, Black-3.webp',
  'Balmain — Logo T-Shirt & Swim Shorts Set, Black-4.webp',
  'Balmain — Logo T-Shirt with Monogram Sleeve Trim, Black.webp',
  'Balmain — Logo T-Shirt with Monogram Sleeve Trim, Black -1.webp',
  'Balmain — Logo T-Shirt with Monogram Sleeve Trim, Black -2.webp',
  'Balmain — Monogram Zip Bomber Jacket, Black.webp',
  'Balmain — Monogram Zip Bomber Jacket, Black-1.webp',
  'Balmain — Monogram Zip Bomber Jacket, Black-2.webp',
  'Balmain — Paris Logo T-Shirt, Black.webp',
  'Balmain — Paris Logo T-Shirt, Black-1.webp',
  'Balmain — Paris Logo T-Shirt, Black-2.webp',
  'Balmain Padded Logo-Tape Gilet.webp',
  'Balmain Padded Logo-Tape Gilet-1.webp',
  'Balmain Padded Logo-Tape Gilet-2.webp',
  'Beymen — Houndstooth Wool-Blend Blazer, Grey.webp',
  'Beymen — Houndstooth Wool-Blend Blazer, Grey-1.webp',
  'Beymen — Houndstooth Wool-Blend Blazer, Grey-2.webp',
  'Beymen — Houndstooth Wool-Blend Blazer, Grey-3.webp',
  'Beymen — Houndstooth Wool-Blend Blazer, Grey-4.webp',
  'Damat Tween — Classic Blazer : Navy.webp',
  'Damat Tween — Classic Blazer : Navy-1.webp',
  'Damat Tween — Classic Blazer : Navy-2.webp',
  'Damat Tween — Classic Blazer : Navy-3.webp',
  'Damat Tween — Classic Blazer : Navy-4.webp',
  'Damat Tween — Classic Blazer : Navy-5.webp',
  'DSQUARED2 — Distressed Logo Hoodie, Olive:Camo.webp',
  'DSQUARED2 — Distressed Logo Hoodie, Olive:Camo-1.webp',
  'DSQUARED2 — Distressed Logo Hoodie, Olive:Camo-2.webp',
  'Fred Perry — Taped Track Jacket, Dark Green:Gold.webp',
  'Fred Perry — Taped Track Jacket, Dark Green:Gold-1.webp',
  'Fred Perry — Taped Track Jacket, Dark Green:Gold-2.webp',
  'Gucci — GG Tape Cotton Piqué Polo, White:Black.webp',
  'Gucci — GG Tape Cotton Piqué Polo, White:Black-1.webp',
  'Gucci — GG Tape Cotton Piqué Polo, White:Black-2.webp',
  'Gucci — Web-Trim Cotton Piqué Polo, Navy.webp',
  'Gucci — Web-Trim Cotton Piqué Polo, Navy-1.webp',
  'Gucci — Web-Trim Cotton Piqué Polo, Navy-2.webp',
  'HUGO (by Hugo Boss) — “HEROES” Crewneck Sweatshirt, Black.webp',
  'HUGO (by Hugo Boss) — “HEROES” Crewneck Sweatshirt, Black-1.webp',
  'HUGO (by Hugo Boss) — “HEROES” Crewneck Sweatshirt, Black-2.webp',
  'HUGO (by Hugo Boss) — Reverse Box Logo Crewneck Sweatshirt, Black.webp',
  'HUGO (by Hugo Boss) — Reverse Box Logo Crewneck Sweatshirt, Black-1.webp',
  'HUGO (by Hugo Boss) — Reverse Box Logo Crewneck Sweatshirt, Black-2.webp',
  'HUGO (by Hugo Boss) — Silver Sequin Dinner Blazer, Black Shawl Lapel.webp',
  'HUGO (by Hugo Boss) — Silver Sequin Dinner Blazer, Black Shawl Lapel-1.webp',
  'HUGO (by Hugo Boss) — Silver Sequin Dinner Blazer, Black Shawl Lapel-2.webp',
  'HUGO BOSS — Wool-Blend Tweed Blazer, Dark Brown:Black.webp',
  'HUGO BOSS — Wool-Blend Tweed Blazer, Dark Brown:Black-1.webp',
  'HUGO BOSS — Wool-Blend Tweed Blazer, Dark Brown:Black-2.webp',
  'Just Cavalli – Graphic Crewneck Sweatshirt .webp',
  'Just Cavalli – Graphic Crewneck Sweatshirt-1.webp',
  'Just Cavalli — “West Coast” Graphic Hoodie, Beige.webp',
  'Just Cavalli — “West Coast” Graphic Hoodie, Beige-1.webp',
  'Just Cavalli — “West Coast” Graphic Hoodie, Beige-2.webp',
  'Just Cavalli — Graffiti Logo Crewneck Sweatshirt, Beige.webp',
  'Just Cavalli — Graffiti Logo Crewneck Sweatshirt, Beige-1.webp',
  'Just Cavalli — Graffiti Logo Crewneck Sweatshirt, Beige-2.webp',
  'Just Cavalli — Graffiti Logo Crewneck Sweatshirt, Beige-3.webp',
  'Just Cavalli — Graffiti Script Crewneck Sweatshirt, Black:White.webp',
  'Just Cavalli — Graffiti Script Crewneck Sweatshirt, Black:White-1.webp',
  'Just Cavalli — Graffiti Script Crewneck Sweatshirt, Black:White-2.webp',
  'Just Cavalli — Graffiti Script Crewneck Sweatshirt, Black:White-3.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Beige .webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Beige-1.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Beige-2.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Beige-3.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Black:Beige.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Black:Beige-1.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Black:Beige-2.webp',
  'Just Cavalli — Logo Crewneck Sweatshirt, Black:Beige-3.webp',
  'Just Cavalli — Skull Graphic Crewneck Sweatshirt, Black.webp',
  'Just Cavalli — Skull Graphic Crewneck Sweatshirt, Black-1.webp',
  'Just Cavalli — Skull Graphic Crewneck Sweatshirt, Black-2.webp',
  'Lufian Lightweight Puffer Gilet.webp',
  'Lufian Lightweight Puffer Gilet-1.webp',
  'Lufian Lightweight Puffer Gilet-2.webp',
  'Moschino — Logo Patch Hoodie, Black.webp',
  'Moschino — Logo Patch Hoodie, Black-1.webp',
  'Moschino — Logo Patch Hoodie, Black-2.webp',
  'Porsche Design — Quilted Stand-Collar Jacket, Black.webp',
  'Porsche Design — Quilted Stand-Collar Jacket, Black-2.webp',
  'Porsche Design — Quilted Stand-Collar Jacket, Black-3.webp',
  'PS Paul Smith — Chest-Patch Crewneck Sweatshirt, Black.webp',
  'PS Paul Smith — Chest-Patch Crewneck Sweatshirt, Black-1.webp',
  'PS Paul Smith — Chest-Patch Crewneck Sweatshirt, Black-2.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-1.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-2.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-3.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-4.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-5.webp',
  'Represent — Oversize T-Shirt + 2x Shorts Set-6.webp',
  'Sandro — Short-Sleeve Print Shirt.webp',
  'Sandro — Short-Sleeve Print Shirt-1.webp',
  'Sandro — Short-Sleeve Print Shirt-2.webp',
  'Sandro Paris – “Mr. Strong” Crewneck Sweatshirt.webp',
  'Sandro Paris – “Mr. Strong” Crewneck Sweatshirt-1.webp',
  'Sandro Paris – “Mr. Strong” Crewneck Sweatshirt-2.webp',
  'Sandro Paris – “Mr. Strong” Crewneck Sweatshirt-3.webp',
  'Sertaç Taşdelen — Summer Set .webp',
  'Sertaç Taşdelen — Summer Set -1.webp',
  'Sertaç Taşdelen — Summer Set -2.webp',
  'Sertaç Taşdelen — Summer Set -3.webp',
  'Sertaç Taşdelen — Summer Set (V-Neck Top & Trousers).webp',
  'Sertaç Taşdelen — Summer Set (V-Neck Top & Trousers)-1.webp',
  'Sertaç Taşdelen — Summer Set (V-Neck Top & Trousers)-2.webp',
  'Vakko — Anchor Patch Cotton Piqué Polo, Black.webp',
  'Vakko — Anchor Patch Cotton Piqué Polo, Black-1.webp',
  'Vakko — Anchor Patch Cotton Piqué Polo, Black-2.webp',
  'Vakko — Striped Cotton Shirt, Beige:White.webp',
  'Vakko — Striped Cotton Shirt, Beige:White-1.webp',
  'Vakko — Striped Cotton Shirt, Beige:White-2.webp',
  'Versace Jeans Couture — Baroque Medallion Crewneck Sweatshirt, Black.webp',
  'Versace Jeans Couture — Baroque Medallion Crewneck Sweatshirt, Black-1.webp',
  'Versace Jeans Couture — Baroque Medallion Crewneck Sweatshirt, Black-2.webp',
  'Versace Jeans Couture — Baroque Medallion Crewneck Sweatshirt, Black-3.webp',
  'Versace Jeans Couture — Eagle Baroque Crewneck Sweatshirt, Black:Gold.webp',
  'Versace Jeans Couture — Eagle Baroque Crewneck Sweatshirt, Black:Gold-1.webp',
  'Versace Jeans Couture — Eagle Baroque Crewneck Sweatshirt, Black:Gold-2.webp',
  'Versace Jeans Couture — Embossed:Gold Logo Crewneck Sweatshirt, Black.webp',
  'Versace Jeans Couture — Embossed:Gold Logo Crewneck Sweatshirt, Black-1.webp',
  'Versace Jeans Couture — Embossed:Gold Logo Crewneck Sweatshirt, Black-2.webp',
  'Versace Jeans Couture — Multicolor Logo Crewneck Sweatshirt, Black.webp',
  'Versace Jeans Couture — Multicolor Logo Crewneck Sweatshirt, Black-1.webp',
  'Versace Jeans Couture — Multicolor Logo Crewneck Sweatshirt, Black-2.webp',
  'Versace Jeans Couture — Patch Logo Crewneck Sweatshirt, Black.webp',
  'Versace Jeans Couture — Patch Logo Crewneck Sweatshirt, Black-1.webp',
  'Versace Jeans Couture — Patch Logo Crewneck Sweatshirt, Black-2.webp',
  'Versace Jeans Couture — Patch Logo Crewneck Sweatshirt, Black-3.webp'
];

// Additional user-provided product image files
GIYIM_FILES.push(
  'Balmain Logo T-Shirt – Black.webp',
  'Just Cavalli Short-Sleeve Shirt – Python Print.webp',
  'Just Cavalli Short-Sleeve Shirt – Python Print-1.webp',
  'Just Cavalli Short-Sleeve Shirt – Python Print-2.webp',
  'Versace Jeans Couture Oversize Shirt – White.webp',
  'Versace Jeans Couture Oversize Shirt – White-1.webp',
  'Versace Jeans Couture Oversize Shirt – White-3.webp'
);

export const AYAKKABI_FILES: string[] = [
  '1.webp',
  '2.webp',
  '3.webp',
  'adidas YEEZY Knit Sneaker – Lime:Volt.webp',
  'adidas YEEZY Knit Sneaker – Lime:Volt-1.webp',
  'adidas YEEZY Knit Sneaker – Lime:Volt-2.webp',
  'adidas YEEZY Knit Sneaker – Lime:Volt-3.webp',
  'adidas YEEZY Knit Sneaker – Lime:Volt-4.webp',
  'Beymen Suede Penny Loafers — Taupe:Beige.webp',
  'Beymen Suede Penny Loafers — Taupe:Beige-1.webp',
  'Beymen Suede Penny Loafers — Taupe:Beige-2.webp',
  'Beymen Suede Penny Loafers — Taupe:Beige-3.webp',
  'Beymen Suede Penny Loafers — Taupe:Beige-4.webp',
  'Camper Ankle Boots – Black Leather.webp',
  'Camper Ankle Boots – Black Leather-1.webp',
  'Camper Ankle Boots – Black Leather-2.webp',
  'Camper Ankle Boots – Black Leather-3.webp',
  'Camper Lace-Up Boots – Black.webp',
  'Camper Lace-Up Boots – Black-1.webp',
  'Camper Lace-Up Boots – Black-2.webp',
  'Camper Lace-Up Boots – Black-3.webp',
  'Camper Lace-Up Boots – Black-4.webp',
  'Dolce & Gabbana Court Sneakers – White:Gold:Black .webp',
  'Dolce & Gabbana Court Sneakers – White:Gold:Black -1.webp',
  'Dolce & Gabbana Court Sneakers – White:Gold:Black -2.webp',
  'Dolce & Gabbana Court Sneakers – White:Gold:Black -3.webp',
  'Dolce & Gabbana Court Sneakers – White:Gold:Black -4.webp',
  'DSQUARED2 Retro Runner – Black:White .webp',
  'DSQUARED2 Retro Runner – Black:White-1.webp',
  'DSQUARED2 Retro Runner – Black:White -2.webp',
  'DSQUARED2 Retro Runner – Black:White -3.webp',
  'DSQUARED2 Retro Runner – Black:White -4.webp',
  'Giuseppe Zanotti High-Top – Croc Embossed.webp',
  'Giuseppe Zanotti High-Top – Croc Embossed-1.webp',
  'Giuseppe Zanotti High-Top – Croc Embossed-2.webp',
  'Giuseppe Zanotti High-Top – Croc Embossed-3.webp',
  'Giuseppe Zanotti Woven Slip-On Loafers – Navy .webp',
  'Giuseppe Zanotti Woven Slip-On Loafers – Navy -1.webp',
  'Giuseppe Zanotti Woven Slip-On Loafers – Navy -2.webp',
  'Giuseppe Zanotti Woven Slip-On Loafers – Navy -3.webp',
  'Giuseppe Zanotti Woven Slip-On Loafers – Navy -4.webp',
  'Gucci GG Canvas Espadrilles – Beige:Blue.webp',
  'Gucci GG Canvas Espadrilles – Beige:Blue-1.webp',
  'Gucci GG Canvas Espadrilles – Beige:Blue-2.webp',
  'Gucci GG Canvas Espadrilles – Beige:Blue-3.webp',
  'Gucci GG Canvas Espadrilles – Beige:Blue-4.webp',
  'Gucci GG Leather Espadrilles – Blue.webp',
  'Gucci GG Leather Espadrilles – Blue-1.webp',
  'Gucci GG Leather Espadrilles – Blue-2.webp',
  'Gucci GG Leather Espadrilles – Blue-3.webp',
  'Gucci GG Leather Espadrilles – Blue-4.webp',
  'Gucci Rhyton Logo Sneakers – Off-White.webp',
  'Gucci Rhyton Logo Sneakers – Off-White-1.webp',
  'Gucci Rhyton Logo Sneakers – Off-White-2.webp',
  'Gucci Rhyton Logo Sneakers – Off-White-3.webp',
  'Gucci Rhyton Logo Sneakers – Off-White-4.webp',
  'Jimmy Choo “JC Logo” Sneakers – Triple-White.webp',
  'Jimmy Choo “JC Logo” Sneakers – Triple-White-1.webp',
  'Jimmy Choo “JC Logo” Sneakers – Triple-White-2.webp',
  'Jimmy Choo “JC Logo” Sneakers – Triple-White-3.webp',
  'Jimmy Choo “JC Logo” Sneakers – Triple-White-4.webp',
  'Louis Vuitton Monogram Driver Loafers – Blue.webp',
  'Louis Vuitton Monogram Driver Loafers – Blue-1.webp',
  'Louis Vuitton Monogram Driver Loafers – Blue-2.webp',
  'Louis Vuitton Monogram Driver Loafers – Blue-3.webp',
  'Louis Vuitton Monogram Driver Loafers – Blue-4.webp',
  'New Balance Retro Runner – Black.webp',
  'New Balance Retro Runner – Black-1.webp',
  'New Balance Retro Runner – Black-2.webp',
  'New Balance Retro Runner – Black-3.webp',
  'New Balance Retro Runner – Black-4.webp',
  'Saint Laurent High-Top Sneakers.webp',
  'Saint Laurent High-Top Sneakers-1.webp',
  'Saint Laurent High-Top Sneakers-2.webp',
  'Saint Laurent High-Top Sneakers-3.webp',
  'Saint Laurent High-Top Sneakers-4.webp',
  'Valentino Garavani Chunky Sneakers – White:Grey .webp',
  'Valentino Garavani Chunky Sneakers – White:Grey -1.webp',
  'Valentino Garavani Chunky Sneakers – White:Grey -2.webp',
  'Valentino Garavani Chunky Sneakers – White:Grey -3.webp',
  'Valentino Garavani Chunky Sneakers – White:Grey -4.webp',
  'Versace Jeans Couture Logo Sneakers – Black:Gold.webp',
  'Versace Jeans Couture Logo Sneakers – Black:Gold-1.webp',
  'Versace Jeans Couture Logo Sneakers – Black:Gold-2.webp',
  'Versace Jeans Couture Logo Sneakers – Black:Gold-3.webp',
  'Versace Jeans Couture Logo Sneakers – Black:Gold-4.webp',
  // Exclude any filenames that include 'eksik'
];

function toFileBase(name: string): string {
  // Strip parenthetical qualifiers and replace slashes with colons to match filenames
  return name.replace(/\s*\([^)]*\)/g, '').replace(/[\/]/g, ':').trim();
}

function groupByBase(files: string[]): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  files
    .filter(f => !/^eksik/i.test(f) && !/\beksik/i.test(f))
    .forEach(file => {
      const withoutExt = file.replace(/\.(jpe?g|webp)$/i, '');
      const base = withoutExt.replace(/-\d+$/i, '');
      if (!map[base]) map[base] = [];
      map[base].push(file);
    });
  // Custom sorting for specific products
  Object.keys(map).forEach(base => {
    map[base].sort((a, b) => {
      // Special cases for specific products
      if (base.includes('Saint Laurent High-Top Sneakers')) {
        // Saint Laurent: prioritize -2.webp as main image
        if (a.includes('-2.webp')) return -1;
        if (b.includes('-2.webp')) return 1;
        if (a.includes('-2.webp')) return -1;
        if (b.includes('-2.webp')) return 1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(a)) return -1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(b)) return 1;
        return a.localeCompare(b);
      } else if (base.includes('Giuseppe Zanotti High-Top – Croc Embossed')) {
        // Giuseppe Zanotti: prioritize -1.webp as main image
        if (a.includes('-1.webp')) return -1;
        if (b.includes('-1.webp')) return 1;
        if (a.includes('-1.webp')) return -1;
        if (b.includes('-1.webp')) return 1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(a)) return -1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(b)) return 1;
        return a.localeCompare(b);
      } else if (base.includes('Dolce & Gabbana Court Sneakers')) {
        // Dolce & Gabbana: prioritize -1.webp as main image
        if (a.includes('-1.webp')) return -1;
        if (b.includes('-1.webp')) return 1;
        if (a.includes('-1.webp')) return -1;
        if (b.includes('-1.webp')) return 1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(a)) return -1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(b)) return 1;
        return a.localeCompare(b);
      } else if (base.includes('Gucci Rhyton Logo Sneakers')) {
        // Gucci Rhyton: prioritize -2.webp as main image
        if (a.includes('-2.webp')) return -1;
        if (b.includes('-2.webp')) return 1;
        if (a.includes('-2.webp')) return -1;
        if (b.includes('-2.webp')) return 1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(a)) return -1;
        if (!/-\d+\.(jpe?g|webp)$/i.test(b)) return 1;
        return a.localeCompare(b);
      } else {
        // Default: base image (no index) is first
        const ai = /-\d+\.(jpe?g|webp)$/i.test(a) ? 1 : 0;
        const bi = /-\d+\.(jpe?g|webp)$/i.test(b) ? 1 : 0;
        return ai - bi || a.localeCompare(b);
      }
    });
  });
  return map;
}

const giyimGrouped = groupByBase(GIYIM_FILES);
const ayakkabiGrouped = groupByBase(AYAKKABI_FILES);

export function getStoreImagesForName(name: string, category: 'Clothing' | 'Shoes' | 'Jackets' | 'Shirts' | 'T-Shirts' | 'Special'): string[] {
  const base = toFileBase(name)
    // remove trailing color descriptors like " — Black" or ", Black"
    .replace(/\s*[—-]\s*black$/i, '')
    .replace(/,\s*black$/i, '')
    .replace(/\s*[—-]\s*white$/i, '')
    .replace(/,\s*white$/i, '')
    .replace(/\s*[—-]\s*beige$/i, '')
    .replace(/,\s*beige$/i, '')
    .replace(/\s*[—-]\s*navy$/i, '')
    .replace(/,\s*navy$/i, '')
    .trim();
  const group = (category === 'Clothing' || category === 'Jackets' || category === 'Shirts' || category === 'T-Shirts' || category === 'Special') ? giyimGrouped : ayakkabiGrouped;
  // Try exact base
  let files = group[base];
  if (!files) {
    // Fallback: try normalized comparisons (handle quotes/dashes/parentheses)
    const norm = (s: string) => s
      .toLowerCase()
      .replace(/\([^)]*\)/g, '') // drop any (...) blocks
      .replace(/[“”"']/g, '') // remove quotes
      .replace(/[–—−-]/g, '-') // normalize dashes
      .replace(/[^a-z0-9:]+/g, ' ') // collapse others
      .replace(/\s+/g, ' ')
      .trim();
    const nBase = norm(base);
    const keys = Object.keys(group);
    const keyExact = keys.find(k => norm(k) === nBase);
    if (keyExact) {
      files = group[keyExact];
    } else {
      const keyStarts = keys.find(k => norm(k).startsWith(nBase) || nBase.startsWith(norm(k)));
      if (keyStarts) {
        files = group[keyStarts];
      } else {
        const keyIncludes = keys.find(k => norm(k).includes(nBase) || nBase.includes(norm(k)));
        if (keyIncludes) files = group[keyIncludes];
      }
    }
  }
  if (!files) return [];
  
  // Apply special sorting rules for specific products
  const sorted = [...files].sort((a, b) => {
    // Saint Laurent High-Top Sneakers: prioritize -2.webp as main image
    if (base.includes('Saint Laurent High-Top Sneakers')) {
      if (a.includes('-2.webp')) return -1;
      if (b.includes('-2.webp')) return 1;
      if (a.includes('-2.webp')) return -1;
      if (b.includes('-2.webp')) return 1;
    }
    // Giuseppe Zanotti High-Top: prioritize -1.webp as main image
    if (base.includes('Giuseppe Zanotti High-Top')) {
      if (a.includes('-1.webp')) return -1;
      if (b.includes('-1.webp')) return 1;
      if (a.includes('-1.webp')) return -1;
      if (b.includes('-1.webp')) return 1;
    }
    // Dolce & Gabbana Court Sneakers: prioritize -1.webp as main image
    if (base.includes('Dolce & Gabbana Court Sneakers')) {
      if (a.includes('-1.webp')) return -1;
      if (b.includes('-1.webp')) return 1;
      if (a.includes('-1.webp')) return -1;
      if (b.includes('-1.webp')) return 1;
    }
    // Gucci Rhyton Logo Sneakers: prioritize -2.webp as main image
    if (base.includes('Gucci Rhyton Logo Sneakers')) {
      if (a.includes('-2.webp')) return -1;
      if (b.includes('-2.webp')) return 1;
      if (a.includes('-2.webp')) return -1;
      if (b.includes('-2.webp')) return 1;
    }
    // Default: base image (no numeric suffix) is first
    const aIsIndexed = /-\d+\.(jpe?g|webp)$/i.test(a) ? 1 : 0;
    const bIsIndexed = /-\d+\.(jpe?g|webp)$/i.test(b) ? 1 : 0;
    return aIsIndexed - bIsIndexed || a.localeCompare(b);
  });
  
  const folder = (category === 'Clothing' || category === 'Jackets' || category === 'Shirts' || category === 'T-Shirts' || category === 'Special') ? 'Giyim' : 'Ayakkabı';
  // Return paths as-is (no conversion needed, files already have correct extensions)
  return sorted.map(f => `/images/store/${folder}/${f}`);
}


